'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../../prismicio-types';

import { useVisible } from '@/hooks';
import styles from './staticCard.module.scss';

type Props = {
  card: Simplify<Content.BenefitsSliceStaticPrimaryCardsItem>;
  index: number;
};

export const StaticCard: FC<Props> = ({ card, index }) => {
  const [isVisible, id] = useVisible();

  return (
    <li
      id={id}
      className={`${styles.staticCard} ${isVisible ? styles.isVisible : ''}`}
      style={{ transitionDelay: `${index * 0.13}s` }}
    >
      <div className={styles.top}>
        <p className={styles.title}>{card.card_title}</p>
      </div>
      <div className={styles.bottom}>
        <p className={styles.value}>{card.value}</p>
        <p className={styles.markWrapper}>
          <span className={styles.mark}>{card.mark}</span>
          <span className={styles.markValue}>{card.mark_value}</span>
        </p>
      </div>
    </li>
  );
};
